import * as React from "react";
import { Header, Navigation, Filter, Footer } from "../../shared";

import "./BookstoreSale.scss";

import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { BookstoreSalesCurrentYear } from './sales-current-year/BookstoreSalesCurrentYear';
import { BookstoreAveragePrice } from "./average-price/BookstoreAveragePrice";
import { BookstoreAverageTicket } from "./average-ticket/BookstoreAverageTicket";
import { BookstoreCouponItem } from "./coupon-item/BookstoreCouponItem";
import { BookstoreRevenue30Days } from "./revenue-30-days/BookstoreRevenue30Days";
import { BookstoreMonthComparative } from "./month-comparative/BookstoreMonthComparative";
import { BookstoreSubjectShare } from "./subject-share/BookstoreSubjectShare";
import { BookstoreCategoryShare } from "./category-share/BookstoreCategoryShare";
import {
  BookstoreProviderFilter,
  BookstoreStoreFilter,
  BookstoreUfFilter,
  BookstoreProductFilter,
  BookstoreCategoryFilter,
  BookstoreDateFilter
} from "src/component/bookstore";
import { Grid, Typography, Tab, AppBar, Tabs, LinearProgress} from "@material-ui/core";
import { SalesForHour } from "./sales-for-hour/SalesForHour";
import { BookstoreRegionShare } from "./region-share/BookstoreRegionShare";
import { BookstoreStoreShare } from "./store-share/BookstoreStoreShare";
import { BookstoreFilterChip } from "../shared/chips/BookstoreFilterChip";
import { client } from 'src';
import { QueryFilter } from 'src/component/shared';

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreSaleProps {}

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreSaleState {
  bookstoreProductFilterChecked : any;
  hasProductFilter: boolean;
  isApplicableProductFilter: boolean;
  value: number;
  waitDataFilter: boolean;
  
}

function TabContainer(props: any) {
  return (
    <Typography component="div" style={{ paddingTop: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

function LinkTab(props: any) {
  return (
    // tslint:disable-next-line:jsx-no-lambda
    <Tab component="a" onClick={event => event.preventDefault()} {...props} />
  );
}

export class BookstoreSale extends React.Component<
  IBookstoreSaleProps,
  IBookstoreSaleState
> {
  constructor(props: IBookstoreSaleProps) {
    super(props);
    this.state = {
      bookstoreProductFilterChecked : null,
      hasProductFilter : false,
      isApplicableProductFilter: false,
      value: 0,
      waitDataFilter: false,
    };
    this.finishLoad = this.finishLoad.bind(this);
  }


  public handleChange = (event: any, value: any) => {

    let waitDataFilter = Object.assign({}, this.state.waitDataFilter);
    if(value === 2) {
      waitDataFilter = true;
    } else {
      waitDataFilter = false;
    }

    this.setState({ value, waitDataFilter });

    this.managerProductFilter(value);

    this.managerDateFilter(value);
  };

  public finishLoad () {
    this.setState({ waitDataFilter: false });
  }

  public render() {

    const filters = [
      <BookstoreCategoryFilter key={1} />,
      <BookstoreProviderFilter key={2} />,
      <BookstoreStoreFilter key={3} />,
      <BookstoreUfFilter key={4} />,
    ];
    if(this.state.isApplicableProductFilter) {
      filters.push(<BookstoreProductFilter key={5} />);
    }

    if(this.state.value === 2) {
      filters.push(<BookstoreDateFilter key={6} finishLoad={this.finishLoad} />);
    }
    

    return (
      <div>
        <Header title={"Análises"} name={"Livrarias"} link={"/dashboard"} />
        <Navigation
          name={"Painel de Vendas"}
          linkDefault={"/bookstore/sale"}
          link={"/bookstore/analytical"}
          linkTitle={"Analítico"}
          painel={2}
          icon={<ChevronRightIcon />}
        />

        <Filter filters={filters} />

        <BookstoreFilterChip />

        <div className="wrapper">
        <AppBar position="static" style={{ backgroundColor: '#FFFF' }}>
            <Tabs fullWidth={true} value={this.state.value} onChange={this.handleChange} centered={true}
            textColor="primary"

            indicatorColor="primary">
              <LinkTab label="Vendas - Acumulado" href="page1" />
              <LinkTab label="Vendas - Dia e Hora" href="page2" />
              <LinkTab label="Share" href="page3" />
            </Tabs>
          </AppBar>
          {this.state.value === 0 && <TabContainer>
            <Grid
            container={true}
            className="publisher-sale-panel panel-grid"
            spacing={16}
          >
            <Grid item={true} xs={12} md={12}>
              <Grid
                container={true}
                className="publisher-sale-panel panel-grid panel-bg-area"
                spacing={16}
              >
                <Grid item={true} xs={12} className="panel-bg">
                  <Typography component="h3" className="panel-head">
                    Ano atual
                  </Typography>
                  <BookstoreSalesCurrentYear />
                </Grid>
              </Grid>
            </Grid>

            <Grid item={true} xs={12}>
              <BookstoreMonthComparative />
            </Grid>
          </Grid>
          </TabContainer>}

          {this.state.value === 1 && <TabContainer>
            <Grid
            container={true}
            className="publisher-sale-panel panel-grid"
            spacing={16}
          >

            <Grid item={true} xs={12} md={12}>
              <Grid
                container={true}
                className="publisher-sale-panel panel-grid panel-bg-area"
                spacing={16}
              >
                <Grid item={true} xs={12} md={12} className="panel-bg">
                  <Typography component="h3" className="panel-head">
                    Média dos últimos 30 dias
                  </Typography>

                  <Grid container={true} spacing={16}>

                    <Grid item={true} xs={4} sm={4}>
                      <BookstoreAveragePrice periodicity="30days" />
                    </Grid>

                    <Grid item={true} xs={4} sm={4}>
                      <BookstoreAverageTicket />
                    </Grid>

                    <Grid item={true} xs={4} sm={4}>
                      <BookstoreCouponItem />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item={true} xs={12}>
              <BookstoreRevenue30Days />
            </Grid>

            <Grid item={true} xs={12}>
              <SalesForHour/>
            </Grid>
          </Grid>

          </TabContainer>}
          {this.state.value === 2 && <TabContainer>
            {this.state.waitDataFilter ? <LinearProgress /> : <Grid
              container={true}
              className="publisher-sale-panel panel-grid"
              spacing={16}
            >

            <BookstoreCategoryShare />
            
            <BookstoreSubjectShare />

            <BookstoreRegionShare/>

            
            <BookstoreStoreShare/>
            
            </Grid>}

          </TabContainer>}

        </div>
        <Footer />
      </div>
    );
  }

  /**
   * Caso o usuário esteja na aba de "Vendas Acumuladas" devemos:
   *    - Suprimir filtros de produto (caso houver);
   *    - Armazenar os filtros de produto suprimidos para quando sair desta aba, reaplicá-los.
   *    - Eliminar menu de produtos das opções de filtro.
   * 
   * Caso o usuário não esteja na aba de "Vendas Acumuladas" 
   *  e tenhamos algum filtro de produto que tinha sido suprimido ao entrar na aba:
   *    - Retornar com o menu de produtos nas opções de filtro
   *    - Reaplicar o filtro.
   * 
   * Caso o usuário não esteja na aba de "Vendas Acumuladas" 
   *  e não tenha nenhum filtro de produto que tinha sido suprimido ao entrar na aba:
   *    - Retornar com o menu de produtos nas opções de filtro
   */
  private managerProductFilter (value: any) {
    if( value === 0 ) {
      this.setState({
        isApplicableProductFilter: false
      });
      this.setState({
        bookstoreProductFilterChecked: QueryFilter.getBookstoreProductFilter(client)
      });
      client.writeData({
        data: {
          FILTER_bookstoreProductFilterChecked: [],
        }
      });
      QueryFilter.updateMutationBookstore();
    } else {
      if (this.state.bookstoreProductFilterChecked != null) {
        client.writeData({
          data: {
            FILTER_bookstoreProductFilterChecked: this.state.bookstoreProductFilterChecked,
          }
        });

        this.setState({
          bookstoreProductFilterChecked: null
        });
        
        QueryFilter.updateMutationBookstore();
      }

      this.setState({
        isApplicableProductFilter: true
      });
    }
  }

  private managerDateFilter (value: any) {
    if( value !== 2 ) {
      client.writeData({
        data: {
          FILTER_bookstoreEndDateFilterChecked: "",
          FILTER_bookstoreInitialDateFilterChecked: "",
        }
      });
      QueryFilter.updateMutationBookstore();
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/sale/BookstoreSale.tsx